import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareRss } from '@fortawesome/free-solid-svg-icons';
import startCase from 'lodash/startCase';
import { FormattedMessage } from 'react-intl';
import { Container, Row, Col, Button } from 'reactstrap';

import env from 'Env';
import { getAuthorNameBySlug } from 'Components/Blog/content/AuthorData';
import BlogPinnedContainer from 'Containers/Blog/BlogPinnedContainer';
import BlogPostItemList from 'Components/Blog/BlogPostItemList';
import BlogPosts from 'Components/Blog/content/BlogPosts';
import BlogProductsContainer from 'Containers/Blog/BlogProductsContainer';
import CategoryTitles from 'Components/Blog/CategoryTitles';
import HomePageDealContainer from 'Containers/HomePage/HomePageDealContainer';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';
import EmailSignupPlacement from 'Components/Banner/EmailSignupPlacement/EmailSignupPlacement';

import 'Components/Blog/BlogPostsPage.scss';
import 'Components/Blog/Shared-Blog.scss';

function BlogPostsPage({
  posts,
  tagged,
  search,
  category,
  page,
  totalResultsSize,
  authorSlug,
}) {
  const rootUrl = `${env.apiProtocol}://${env.apiUrl}`;
  const authorName = getAuthorNameBySlug(authorSlug);

  let path = 'blog';
  let title = 'Fanatical Blog';
  let seoTitle = 'Fanatical Blog | Game news, reviews, competitions and more';
  let description = 'Written by gamers, for gamers, Fanatical Blog will feed you a staple diet of news covering the games that you really care about. Everything from reviews and developer interviews, to amazing competitions and much more.';

  if (tagged !== '') {
    seoTitle = `${startCase(tagged)} posts at Fanatical Blog`;
  }

  if (category) {
    seoTitle = `${startCase(category)} posts at Fanatical Blog`;
    title += ` | ${startCase(category)}`;
    path += `/category/${category}`;
  }

  if (authorSlug) {
    seoTitle = `${authorName} posts at Fanatical Blog`;
    title += ` | ${authorName}`;
    path += `/authors/${authorSlug}`;
  }

  if (CategoryTitles[category]) {
    seoTitle = CategoryTitles[category].title;
    description = CategoryTitles[category].description;
  }

  if (page > 1) {
    seoTitle += ` | Page ${page}`;
    title += ` | Page ${page}`;
  }

  return (
    <main className="fanatical-blog BlogPostsPage">
      <Meta
        title={seoTitle}
        description={description}
        url={path}
        pageType="CollectionPage"
      />
      {window.locale !== 'en' &&
        <NoIndex />
      }
      <Container className="mt-4">
        <h1 className="d-none">
          {title}
        </h1>
        <Row>
          <Col xs={12} lg={8} className="blog-posts">
            {(!tagged && !search && !category && !authorSlug) && <BlogPinnedContainer type="primary" blogCardNameTag="h2" />}
            <BlogPostItemList isMain posts={posts} />

            <BlogPosts
              posts={posts}
              totalResultsSize={totalResultsSize}
              authorSlug={authorSlug}
              category={category}
            />

          </Col>

          <Col xs={12} lg={4} className="BlogPostsPage__aside">
            <HomePageDealContainer blog starDealCardNameTag="h2" />

            <section className="blog-products-container p-3">
              <h2 className="pb-3 h3">
                <FormattedMessage id="blog-posts-page.top-sellers" defaultMessage="Top Sellers" />
              </h2>
              <BlogProductsContainer hitCardLightTheme searchTerm={tagged} hitCardNameTag="h3" />
              <Link to={'/search'} className="btn related-button">
                <FormattedMessage id="blog-posts-page.view-more" defaultMessage="View more" />
              </Link>
            </section>

            <Button
              color="primary"
              tag={'a'}
              href={`${rootUrl}/blog-feed`}
              size="lg"
              className="rss-btn"
            >
              <div className="rss-btn-icon">
                <FontAwesomeIcon icon={faSquareRss} size="lg" color="white" />
              </div>
              <b><FormattedMessage id="blog-posts-page.subscribe-rss" defaultMessage="Subscribe to RSS feed" /></b>
            </Button>

            <EmailSignupPlacement
              appearsOn="blog_main"
              bannerSizes={{ lg: 'portrait', xl: 'portrait', xxl: 'portrait' }}
            />

            <BlogPinnedContainer type="secondary" blogCardNameTag="h2" />
          </Col>
        </Row>
      </Container>
    </main>
  );
}

BlogPostsPage.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  tagged: PropTypes.string,
  search: PropTypes.string,
  category: PropTypes.string,
  totalResultsSize: PropTypes.number,
  page: PropTypes.number,
  authorSlug: PropTypes.string,
};

BlogPostsPage.defaultProps = {
  posts: [],
  tagged: '',
  search: '',
  category: '',
  page: 1,
  totalResultsSize: 0,
  authorSlug: '',
};

export default BlogPostsPage;
